import React from "react";
import AdminStatCard from "./AdminStatCard";
import { QUDA_COLORS } from "@/config/colors";

const AdminQudaStatCard = (props) => (
  <AdminStatCard
    gradientFrom="#00a89e"
    gradientTo={QUDA_COLORS.TEAL_DARK}
    borderColor={QUDA_COLORS.TEAL_LIGHT}
    titleColor="white"
    valueColor="white"
    iconGhostColor="white"
    {...props}
  />
);

export default AdminQudaStatCard;
